import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent'; 
import Tooltip from '@mui/material/Tooltip';
import TablePagination from '@mui/material/TablePagination';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { useGetPendingOrdersCustomerBySellerQuery } from '../../apis/OrderAPi';
import { getUserData } from '../../auth';
import OrderDialog from '../modal/OrderDialog';
import _ from "lodash";

import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField'; // Import TextField for search input


function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const [orderModalOpen, setOrderModalOpen] = React.useState(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  const handleCompleteOrder = () => {
    setOrderModalOpen(true); // Open the order modal dialog
  };

  const handleCloseOrderModal = () => {
    setOrderModalOpen(false); // Close the order modal dialog
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="right">{row.cart.totalPrice}</TableCell>
        <TableCell align="right">{row.cart.quantiteTotal}</TableCell>
         
        <TableCell align="right">
            {row.cart.status === "pending" && (
                <Tooltip title="Process the Order" placement="top">
              <IconButton onClick={handleCompleteOrder} color="primary">
                <FaArrowAltCircleRight />
              </IconButton>
            </Tooltip>
              )}
        </TableCell>
 
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>

         <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ margin: 1 }}>
          <Typography variant="h6" gutterBottom component="div">
            Customer Order Details
          </Typography>

<Typography variant="body1"><strong>Code:</strong> {row.cart.orderNumber}</Typography>
<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>FirstName: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.firstName}</Box>
</Typography>

<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>FastName: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.lastName}</Box>
</Typography>

<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>StreetName: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.streetName}</Box>
</Typography>


<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>City: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.city}</Box>
</Typography>

<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>Country: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.apartment}</Box>
</Typography>


<Typography>
  <Box component="span" sx={{ fontWeight: 'bold' }}>PostCode: </Box>
  <Box component="span" sx={{ fontStyle: 'italic' }}>{row.cart.postCode}</Box>
</Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {row.items.map((item) => (
              <Box
                key={item.id}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: 2,
            border: '1px solid #EF6036',
            borderRadius: 2,
            boxShadow: 1,
            backgroundColor: 'background.paper',
          }}
        >
          <Tooltip title={item.productName} arrow>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', cursor: 'pointer' }}>
              {_.truncate(item.productName, { length: 30, omission: "..." })}
            </Typography>
          </Tooltip>

          <Typography>Price: ${item.productPrice}</Typography>
          <Typography>Quantity: {item.quantity}</Typography>
          <Typography>Total: ${item.total}</Typography>
          <Typography>Earned: ${item.vendorCommissionFee}</Typography>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', marginTop: 1 }}>
            {item.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Item ${index}`}
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '8px',
                  objectFit: 'cover',
                  cursor: 'pointer',
                }}
                onClick={() => handleImageClick(image)}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
</Collapse>

        </TableCell>
      </TableRow>

      {/* Image Preview Dialog */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogContent>
          <img
            src={selectedImage}
            alt="Preview"
            style={{ width: '100%', height: 'auto', maxWidth: '600px' }}
          />
        </DialogContent>
      </Dialog>

      {/* Order Modal Dialog */}
      <OrderDialog
       open={orderModalOpen} 
       onClose={handleCloseOrderModal}
       row={row}           
      />
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    cart: PropTypes.shape({
      id: PropTypes.string.isRequired,
      totalPrice: PropTypes.number.isRequired,
      quantiteTotal: PropTypes.number.isRequired,
      paymentMethod: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        productName: PropTypes.string.isRequired,
        productPrice: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        vendorCommissionFee: PropTypes.number,
        statusVendorTracker: PropTypes.string,
        images: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
  }).isRequired,
};
export default function CollapsibleTable() {
  const userData = getUserData();
  const userId = userData?.uid || '';
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [orderNumber, setOrderNumber] = React.useState(''); // Added search state

  // Added isFetching and orderNumber parameter
  const { data, error, isLoading, isFetching } = useGetPendingOrdersCustomerBySellerQuery(
    {
    sellerId: userId,
    orderNumber: orderNumber,
    page: page,
    size: rowsPerPage,
  },
  { pollingInterval: 5000 } // Poll every 5000ms (5 seconds)
);  
 
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Added search handler
  const handleSearchChange = (event) => {
    setOrderNumber(event.target.value);
    setPage(0); // Reset to first page when searching
  };

  if (isLoading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <CircularProgress />
    </Box>
  );  if (error) return <div>Error: {error.message}</div>;

  return (
    <TableContainer component={Paper}>
      {/* Added search field */}
      <Box sx={{ padding: 2 }}>
        <TextField
          fullWidth
          label="Search by Order Number"
          variant="outlined"
          value={orderNumber}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: isFetching ? (
              <InputAdornment position="end">
                <CircularProgress size={20} />
              </InputAdornment>
            ) : null,
          }}
        />
      </Box>

      <Box sx={{ overflowX: 'auto' }}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Quantity</TableCell>
              <TableCell align="right">Process</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.cartItems.map((row) => (
              <Row key={row.cart.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </Box>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data.totalItems}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}